import type {ReactElement} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Icon} from '@Components/icon-v2';
import {FlatIconColor, FlatIconColorType, IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {PulsatingDot} from '@Components/poster-editor/components/pulsating-dot';
import type {AddItemGridButtonProps} from './add-item-grid-button.types';
import styles from './add-item-grid-button.module.scss';

export function AddItemGridButton({id, icon, label, onClick, isAi = false, hasPulsatingDot = false, labelClassName = ''}: AddItemGridButtonProps): ReactElement {
  const getPulsatingDot = (): ReactElement | null => {
    if (!hasPulsatingDot) {
      return null;
    }
    return <PulsatingDot containerClassname={`_position-absolute ${styles.pulsatingDot}`} />;
  };

  return (
    <ClickableDiv id={id} className={styles.gridButton} onClick={onClick} aria-label={label}>
      <div className={`_position-relative ${styles.iconWrapper}`}>
        <Icon
          icon={icon}
          type={IconType.FLAT}
          shape={IconShape.CIRCLE}
          size={IconSize.SIZE_ICON_24}
          flatIconType={{color: isAi ? FlatIconColor.AI : FlatIconColor.NEUTRAL, type: FlatIconColorType.DEFAULT}}
        />
        {getPulsatingDot()}
      </div>
      <Text className={`${styles.label} ${isAi ? 'content-ai' : ''} ${labelClassName}`} val={label} size={TextSize.MD} />
    </ClickableDiv>
  );
}
